module.exports = __webpack_public_path__ + "img/Shay Shelnutt.c88be935.jpg";